import { useGlobalState } from "../contexts/GlobalStateContext";

export function EscalateButton({ post }) {
  const { removePostWithFade, logOut, resetGlobalState } = useGlobalState();


  const baseUrl = process.env.REACT_APP_BASE_URL;
  // Handle the click for like/unlike
  const escalatePost = () => {

    const payload = { uuid: post.uuid, escalated: true };

    fetch(`${baseUrl}/php/escalate_post.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.success) {
            removePostWithFade(post.uuid);
        } else if (data.status === "error"){
          logOut();
          resetGlobalState();
        } else {
          console.error("Failed to escalate post:", data.message);
        }
      })
      .catch((error) => {
        console.error("Error during escalation:", error);
      });
  };

  return (
    <div className="escalate" style={{ backgroundColor: "red", padding: "4px 10px" }} onClick={escalatePost}>
      Escalate
    </div>
  );
}
